export const FETCH_RUN_DETAILS = 'FETCH_RUN_DETAILS'
export const ACTIONS = 'Actions'
export const SUBSCRIBERS = 'Subscribers'
export const TOPICS = 'Topics'



// WEBPACK FOOTER //
// ./src/pages/integration-reports/constants.ts